import { EmptyState } from 'shared/ui'
import campaigns_preview from 'shared/assets/images/campaigns/campaigns_preview.png'
import { getCDNAssetURL } from 'shared/lib'
import { CampaignsHelpGuideButton, NewCampaign } from 'pages/campaigns/actions'
import styles from './styles.module.scss'

export const EmptyStateCampaigns = () => {
  return (
    <>
      <EmptyState
        variant={'preview'}
        previewImg={<img alt='Campaigns preview' src={getCDNAssetURL(campaigns_preview)} />}
        title={'Create your first campaign'}
        subtitle={'Send multi-step SMS and ringless voicemail campaigns'}
        actions={
          <>
            <NewCampaign />
            <CampaignsHelpGuideButton className={styles.helpGuideButton} />
          </>
        }
      />
    </>
  )
}
